import { IconLink } from '@tabler/icons-react';

import type { JoinDatasetsInput, JoinDatasetsOutput } from './schema.ts';
import { ToolCompleteBadges } from '#plugin-chat/components/tool-display/ToolCompleteBadges.tsx';
import { ToolDisplay } from '#plugin-chat/components/tool-display/ToolDisplay.tsx';
import type { ToolProgressComponent } from '#plugin-chat/lib/tool/progress-registry.ts';

/**
 * UI component for JoinDatasetsTool.
 */
export function RenderJoinDatasetsTool({ args }: { args: JoinDatasetsInput }) {
  return (
    <ToolDisplay>
      <ToolDisplay.Running>Joining datasets...</ToolDisplay.Running>
      <ToolDisplay.Complete color="var(--mantine-color-blue-4)" icon={IconLink}>
        <span>Datasets joined</span>
        <ToolCompleteBadges outputDataset={args?.outputDataset} rowCount={undefined} />
      </ToolDisplay.Complete>
      <ToolDisplay.Error>Failed to join datasets</ToolDisplay.Error>
    </ToolDisplay>
  );
}

/**
 * Progress component for JoinDatasetsTool.
 *
 * Rendered inside the "AiPSO Agent is ..." progress bubble while the tool is running.
 */
export const ProgressJoinDatasetsTool: ToolProgressComponent<JoinDatasetsInput, JoinDatasetsOutput> = () => (
  <>joining datasets...</>
);
